import { MILES_LIST } from './actionType'

//
export const MileList = () => {
  return {
    type: MILES_LIST,
  }
}
